module.exports = [{
      plugin: require('/Users/evelyncho/daily-bruin/PRILUSBY/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/evelyncho/daily-bruin/PRILUSBY/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/evelyncho/daily-bruin/PRILUSBY/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"G-1D4G812DSQ","head":true,"anonymize":true},
    }]
